<template>
  <div class="d-flex flex-column flex-grow-1">
    <TabHeader :header="$t('js.sidebar.headers.amendments')" />
    <div class="flex-grow-1 p-3 overflow-auto bg-blur-dark pretty-scroll-theme" id="chat" @scroll="checkScroll"
      style="overflow-y: auto; height: 0;">
      <div v-if="amendments?.length < 1" class="text-white-50 font-italic text-center">
        {{ $t("js.sidebar.amendments.no_amendments") }}
      </div>
      <Amendment v-for="item in amendments" :item="item" :key="`amendment_${item.id}`" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "pinia";
import TabHeader from "./TabHeader.vue";
import Amendment from "@/components/shared/posts/Amendment.vue";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import { useVotingModulesStore } from "@/entrypoints/stores/voting_modules";
import type { UserPost, Slide } from "@/types";

export default defineComponent({
  name: "Amendments",
  components: { Amendment, TabHeader },
  data() {
    return {
      scrolled: false,
    }
  },
  computed: {
    ...mapState(usePresentationStore, ["slides"]),
    ...mapState(useVotingModulesStore, ["posts"]),
    amendments() {
      return this.posts?.filter((p: UserPost) => p.type === "Amendment");
    },
    ballotSlides() {
      return this.slides?.filter((s: Slide) => s.type === "Slides::BallotSlide");
    },
  },
  watch: {
    posts: {
      handler() {
        if (!this.scrolled) {
          this.$nextTick(function () {
            const d = $("#chat");
            d.scrollTop(d.prop("scrollHeight"));
          });
        }
      }, deep: true,
    },
  },
  methods: {
    checkScroll() {
      const d = $("#chat");
      this.scrolled = (d.scrollTop()) < (d.prop("scrollHeight") - d.prop("offsetHeight"));
    }
  },
  mounted() {
    this.$nextTick(function () {
      const d = $("#chat");
      d.scrollTop(d.prop("scrollHeight"));
    });
  },
});
</script>
